import IconsTextNavigation from 'components/global/IconsTextNavigation'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import RulesAndregulationModal from '../Modals/RulesAndRegulation/RulesAndregulation'

const RulesAndRegulations: React.FC = () => {
  const {
    rulesAndRegulationModal,
    setRulesAndRegulationModal,
    rulesAndRegulation,
  } = leagueEventStore(store => ({
    rulesAndRegulationModal: store.rulesAndRegulationModal,
    setRulesAndRegulationModal: store.setRulesAndRegulationModal,
    rulesAndRegulation: store.rulesAndRegulation,
  }))

  return (
    <>
      <div onClick={() => setRulesAndRegulationModal(true)}>
        <IconsTextNavigation
          iconName="Info"
          heading="Rules and Regulations"
          isCompleted={rulesAndRegulation.length > 0}
        />
      </div>

      {rulesAndRegulationModal && <RulesAndregulationModal />}
    </>
  )
}

export default RulesAndRegulations
